import * as types from './actionTypes';
import Immutable from 'seamless-immutable';

const stateName = 'contributorExp';

const initialState = Immutable({
  loading: false,
  contributorExpData: [],
  contributorData: [],
  contributorTopData: [],
  followLoad: false,
  isFollowing: false,
  followId: null
});

export default function reduce(state = initialState, action = {}) {
  switch (action.type) {
    case types.LOADING:
      return {
        ...state,
        loading: true,
      };
    case types.LOAD_DATA:
      return {
        ...state,
        loading: false,
        contributorExpData: action.contributorDetails,
        contributorData: action.contributorData,
        contributorTopData: action.constributorTops,
        isFollowing: action.isFollowing,
        followId: action.followId
      };
    case types.FOLLOW:
      return {
        ...state,
        followLoad: false,
        isFollowing: true
      };
    case types.UNFOLLOW:
      return {
        ...state,
        followLoad: false,
        isFollowing: false
      };
    case types.FOLLOW_LOAD:
      return {
        ...state,
        followLoad: true
      };
    default:
      return state;
  }
}

//Selectors
export function getValue(state, key) {
  const value = state[stateName][key];
  switch (key) {
    default:
      return value;
  }
}

export function getAllValues(state, key) {
  return state['contributorExp'];
}
